import { render } from "./InformacoesCorretor.vue?vue&type=template&id=fc76bfa6"
import script from "./InformacoesCorretor.vue?vue&type=script&lang=js"
export * from "./InformacoesCorretor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__